import { gql } from 'graphql-tag';

export const GET_SUPPLIERS_WITHOUT_ACCOUNT_PAYABLE = gql`
  query Id14d044d2e276ec492e24b31097efaefb(
    $companyId: ID!
    $filter: SupplierFilter
    $after: ID
  ) {
    __typename
  }
`;
